import { render, staticRenderFns } from "./MediaChangeReviewDialog.vue?vue&type=template&id=25f23b9e"
import script from "./MediaChangeReviewDialog.vue?vue&type=script&lang=ts"
export * from "./MediaChangeReviewDialog.vue?vue&type=script&lang=ts"
import style0 from "./MediaChangeReviewDialog.vue?vue&type=style&index=0&id=25f23b9e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports